export default __webpack_public_path__ + "static/space-mob-1d42a9163e0d2be76d0af634bdbbc2f6.jpg";